import { Anime, AnimeSearchResult } from '@/types/anime'

class AniListService {
  private async fetchFromAPI(endpoint: string): Promise<any> {
    try {
      const response = await fetch(endpoint)
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      return await response.json()
    } catch (error) {
      console.error('API Error:', error)
      throw error
    }
  }

  async getTrendingAnime(perPage: number = 20, page: number = 1): Promise<Anime[]> {
    return await this.fetchFromAPI(`/api/anime/trending?page=${page}&perPage=${perPage}`)
  }

  async getPopularAnime(perPage: number = 20, page: number = 1): Promise<Anime[]> {
    return await this.fetchFromAPI(`/api/anime/popular?page=${page}&perPage=${perPage}`)
  }

  async getTopRatedAnime(perPage: number = 20, page: number = 1): Promise<Anime[]> {
    return await this.fetchFromAPI(`/api/anime/top-rated?page=${page}&perPage=${perPage}`)
  }

  async searchAnime(search: string, perPage: number = 20, page: number = 1): Promise<AnimeSearchResult> {
    return await this.fetchFromAPI(`/api/anime/search?query=${encodeURIComponent(search)}&page=${page}&perPage=${perPage}`)
  }

  async getAnimeById(id: number): Promise<Anime> {
    return await this.fetchFromAPI(`/api/anime/${id}`)
  }

  async getAnimeByGenre(genre: string, perPage: number = 20, page: number = 1): Promise<Anime[]> {
    return await this.fetchFromAPI(`/api/anime/genre/${encodeURIComponent(genre)}?page=${page}&perPage=${perPage}`)
  }

  async getAnimeByYear(year: number, perPage: number = 20, page: number = 1): Promise<Anime[]> {
    return await this.fetchFromAPI(`/api/anime/year/${year}?page=${page}&perPage=${perPage}`)
  }
}

export const anilistService = new AniListService()
